import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { friendlyAuthError } from '../../auth';
import { useSession } from '../../state/session';
import { AuthLayout } from './AuthLayout';

/** Where emailed links and redirect providers come back to. */
export function AuthCallback() {
  const { auth, start, refresh } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const once = useRef(false);
  useEffect(() => {
    if (!auth || once.current) return;
    once.current = true;
    (async () => {
      try {
        const to = await auth.completeSignIn();
        if (!(await auth.current())) { await start(); navigate('/sign-in', { replace: true }); return; }
        await refresh();
        navigate(to, { replace: true });
      } catch (e) {
        setError(friendlyAuthError(e));
      }
    })();
  }, [auth, start, refresh, navigate]);
  return (
    <AuthLayout title={error ? 'That link didn’t work' : 'Signing you in…'}>
      {error
        ? <><div className="el-error-box" role="alert">{error}</div><p style={{ margin: 0 }}>Links work once and expire within the hour. <Link to="/sign-in">Try signing in again</Link>.</p></>
        : <p className="el-muted" style={{ margin: 0 }}>One moment.</p>}
    </AuthLayout>
  );
}
